module.exports = __webpack_public_path__ + "static/media/IMG_20201031_0018.418715fe.jpg";